// Cravy Home - Statement v2: photos are clipped to a chosen shape, with an
// editable shape / fill colour / outline per line (Theme editor > Home - Statement).
// Registered as data-slice="statement2". The original `statement` component in
// cravy-sections2.js is left untouched, so removing the <script> tag for this file
// from sections/cr-home-statement.liquid (and switching data-slice back to
// "statement") restores the old behaviour.
// Uses globals from earlier scripts: React, H, P, useIsMobile (cravy-sections1.js)
// and Reveal (cravy-anims.js). They are only read at render time.
(function () {
  window.CravyHome = window.CravyHome || {};
  var UID = 0;

  function scallopPath(n, R, r) {
    var d = '';
    for (var i = 0; i <= n; i++) {
      var a = (i / n) * Math.PI * 2 - Math.PI / 2;
      var x = 50 + R * Math.cos(a);
      var y = 50 + R * Math.sin(a);
      d += i === 0
        ? 'M ' + x.toFixed(2) + ' ' + y.toFixed(2)
        : ' A ' + r + ' ' + r + ' 0 0 1 ' + x.toFixed(2) + ' ' + y.toFixed(2);
    }
    return d + ' Z';
  }

  function starPath(n, outer, inner, cy) {
    var d = '';
    for (var i = 0; i < n * 2; i++) {
      var rad = i % 2 === 0 ? outer : inner;
      var a = (i / (n * 2)) * Math.PI * 2 - Math.PI / 2;
      d += (i === 0 ? 'M ' : ' L ') + (50 + rad * Math.cos(a)).toFixed(2) + ' ' + (cy + rad * Math.sin(a)).toFixed(2);
    }
    return d + ' Z';
  }

  // All shapes are drawn in a 100 x 100 box.
  var SHAPES = {
    flower: scallopPath(10, 40, 14),
    blob: 'M50 4 C72 2 94 16 95 40 C96 62 84 88 60 94 C38 99 12 88 7 64 C2 42 10 20 28 10 C36 6 42 5 50 4 Z',
    circle: 'M 4 50 A 46 46 0 1 1 96 50 A 46 46 0 1 1 4 50 Z',
    square: 'M 6 6 L 94 6 L 94 94 L 6 94 Z',
    rounded: 'M 24 6 L 76 6 Q 94 6 94 24 L 94 76 Q 94 94 76 94 L 24 94 Q 6 94 6 76 L 6 24 Q 6 6 24 6 Z',
    star: starPath(5, 48, 21, 54),
    heart: 'M 50 92 C 12 64 4 42 4 28 C 4 14 15 6 28 6 C 38 6 46 12 50 21 C 54 12 62 6 72 6 C 85 6 96 14 96 28 C 96 42 88 64 50 92 Z',
    hexagon: 'M 50 4 L 90 27 L 90 73 L 50 96 L 10 73 L 10 27 Z',
    diamond: 'M 50 3 L 97 50 L 50 97 L 3 50 Z'
  };

  // Where the left / right photo sits for each hovered line (same as the original).
  var POS = [
    { L: { top: '6%', left: '-4%', rot: -12 }, R: { top: '52%', right: '-5%', rot: 10 } },
    { L: { top: '40%', left: '-6%', rot: 8 }, R: { top: '4%', right: '-3%', rot: -9 } },
    { L: { top: '18%', left: '-3%', rot: -7 }, R: { top: '34%', right: '-6%', rot: 12 } },
    { L: { top: '55%', left: '-5%', rot: 11 }, R: { top: '14%', right: '-4%', rot: -11 } },
    { L: { top: '30%', left: '-4%', rot: -10 }, R: { top: '48%', right: '-3%', rot: 7 } }
  ];

  // Used when a setting is left blank in the theme editor.
  var DEF = [
    { w: 'CATEGORY LEADING', shape: 'flower', fill: '#1b5536' },
    { w: 'FROZEN FRIES', shape: 'blob', fill: '#1a1a1a' },
    { w: 'THAT EVERYONE LOVES!', shape: 'flower', fill: '#411215' },
    { w: 'FRESH , EXTRA CRISPY', shape: 'blob', fill: '#1b5536' },
    { w: '& PURE FUN !', shape: 'flower', fill: '#1a1a1a' }
  ];

  // One photo, clipped to the chosen shape, with the outline drawn on top.
  function StmtPhoto(props) {
    var h = React.createElement;
    var d = SHAPES[props.shape] || SHAPES.flower;
    var clipId = 'clip-' + props.cid;
    return h('svg', {
      viewBox: '0 0 100 100',
      style: {
        display: props.visible ? 'block' : 'none',
        width: '100%',
        height: 'auto',
        aspectRatio: '1 / 1',
        overflow: 'visible',
        filter: 'drop-shadow(0 18px 30px rgba(0,0,0,0.18))',
        animation: props.anim
      }
    },
    h('defs', null, h('clipPath', { id: clipId }, h('path', { d: d }))),
    h('path', { d: d, fill: props.fill }),
    props.src ? h('image', {
      href: props.src,
      x: 0,
      y: 0,
      width: 100,
      height: 100,
      preserveAspectRatio: 'xMidYMid slice',
      clipPath: 'url(#' + clipId + ')'
    }) : null,
    props.sw > 0 ? h('path', {
      d: d,
      fill: 'none',
      stroke: props.stroke,
      strokeWidth: props.sw,
      strokeLinejoin: 'round',
      vectorEffect: 'non-scaling-stroke'
    }) : null);
  }

  function Statement2(props) {
    var h = React.createElement;
    var c = props.cfg || {};
    var hs = React.useState(2);
    var hov = hs[0];
    var setHov = hs[1];
    var us = React.useState(function () { return 'stmt' + (++UID); });
    var uid = us[0];
    var m = useIsMobile();

    var words = DEF.map(function (d, i) {
      var n = i + 1;
      return {
        w: P(c['word' + n], d.w),
        imgL: P(c['img' + n + 'L'], ''),
        imgR: P(c['img' + n + 'R'], ''),
        shape: P(c['shape' + n], d.shape),
        fill: P(c['fill' + n], d.fill),
        stroke: P(c['stroke' + n], '#000000'),
        sw: Number(P(c['sw' + n], 4))
      };
    });

    var bg = P(c.bg, 'var(--cravy-white)');
    var accent = P(c.accent, 'var(--cravy-red)');
    var a = POS[hov];
    var packW = m ? 'min(42vw,180px)' : 'clamp(180px,20vw,340px)';
    var Ltop = m ? (hov % 2 ? '74%' : '3%') : a.L.top;
    var Lleft = m ? '-9%' : a.L.left;
    var Rtop = m ? (hov % 2 ? '4%' : '70%') : a.R.top;
    var Rright = m ? '-9%' : a.R.right;

    function side(isL) {
      var pos = isL ? a.L : a.R;
      var edge = isL ? 'left' : 'right';
      var st = {
        position: 'absolute',
        top: isL ? Ltop : Rtop,
        width: packW,
        transform: 'rotate(' + pos.rot + 'deg)',
        transition: 'top .7s cubic-bezier(.22,.9,.3,1), ' + edge + ' .7s cubic-bezier(.22,.9,.3,1), transform .7s cubic-bezier(.22,.9,.3,1)',
        pointerEvents: 'none',
        zIndex: 1
      };
      st[edge] = isL ? Lleft : Rright;
      return h('div', { 'aria-hidden': 'true', style: st }, words.map(function (s, i) {
        return h(StmtPhoto, {
          key: i,
          cid: uid + (isL ? 'L' : 'R') + i,
          src: isL ? s.imgL : s.imgR,
          shape: s.shape,
          fill: s.fill,
          stroke: s.stroke,
          sw: s.sw,
          visible: i === hov,
          anim: i === hov ? (isL ? 'fadein .5s ease both' : 'fadein .5s ease .08s both') : 'none'
        });
      }));
    }

    return h('section', {
      'data-screen-label': 'Statement',
      style: {
        background: bg,
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        padding: '90px clamp(20px,6vw,100px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box'
      }
    },
    side(true),
    side(false),
    h(Reveal, { kind: 'up', style: { position: 'relative', textAlign: 'center', zIndex: 2 } },
      words.map(function (s, i) {
        return h('div', {
          key: i,
          onMouseEnter: function () { setHov(i); },
          onClick: function () { setHov(i); },
          style: {
            fontFamily: 'var(--font-statement)',
            fontWeight: 400,
            fontSize: m ? 'clamp(49px,13.65vw,83px)' : 'clamp(64px,9.5vw,150px)',
            lineHeight: m ? 0.9 : 0.82,
            letterSpacing: '-0.09em',
            textTransform: 'uppercase',
            color: i === hov ? accent : '#000',
            transition: 'color .35s ease',
            cursor: 'default',
            whiteSpace: m ? 'normal' : 'nowrap'
          },
          dangerouslySetInnerHTML: H(s.w)
        });
      })));
  }

  window.CravyHome.statement2 = Statement2;
})();
